import React from "react";
import { PageHero, FeatureList } from "../components/PageShells";
import ProductShowcase from "../components/ProductShowcase";
import AegHighlight from "../components/AegHighlight";
import LogoMarquee from "../components/LogoMarquee";
import FAQSection from "../components/FAQSection";

const Thuisbatterijen = () => (
  <main data-testid="batteries-page">
    <PageHero
      eyebrow="Thuisbatterijen"
      title="De slimste manier om je zonne-energie 24/7 te gebruiken."
      subtitle="Wij installeren premium thuisbatterijen die je opgewekte stroom opslaan voor 's avonds, 's nachts en op bewolkte dagen. Klaar voor het einde van de salderingsregeling."
      image="/images/thuisbatterijen-hero.png"
    />
    <FeatureList
      title="Waarom een thuisbatterij van Helios Bright?"
      items={[
        { title: "Tot 90% eigen verbruik", desc: "Verhoog het gebruik van eigen zonnestroom drastisch." },
        { title: "Bescherming tegen prijsstijgingen", desc: "Minder afhankelijk van dynamische energieprijzen." },
        { title: "Noodstroom mogelijk", desc: "Optioneel uitbreidbaar met backup-functionaliteit." },
        { title: "10 jaar garantie", desc: "Op alle premium accusystemen en installatie." },
        { title: "Modulair uitbreidbaar", desc: "Begin klein, breid later uit naar 30+ kWh." },
        { title: "App-monitoring", desc: "Real-time inzicht in productie, verbruik en besparing." },
      ]}
    />
    <ProductShowcase />
    <AegHighlight />
    <LogoMarquee />
    <FAQSection />
  </main>
);

export default Thuisbatterijen;
